  <template>
    <div class="legend-wrapper" v-show="org.colors && org.colors.length">
      <div style="grid-row: span 2" class="legend-section">
        <h3 v-if="leaseStatus">Lease Status</h3>
        <h3 v-else>Unit Status</h3>

        <br/>
        <div class="legend-list">
          <div v-for="item in filteredColors" :key="item._id" class="legend-row">
            <span class="dot" :style="{backgroundColor: item.color}" ></span>
            <span class="type">{{ item.type }}</span>
          </div>
        </div>
      </div>

      <div class="legend-section">
        <h3>Parking Prices</h3>
        <br/>
        <div class="legend-list">
          <div
            v-for="(price, type) in parkingPricing.qualityPricing"
            :key="type"
            v-if="type !== '_id' && parkingPricing && parkingPricing.qualityPricing"
            class="legend-row"
          >
            <span><strong>{{type}}:</strong></span>
            <span>{{$options.filters.currencySign(price, $root.state.facilityData)}}</span>
          </div>
        </div>
      </div>

      <div class="legend-section">
        <div class="fee-row" v-if="securityFeeEnabled">
          <strong>{{ securityFeeLabel }} Fee:</strong>
          <span>{{ facilityData.securityFee.fee / 100 | currencySign($root.state.facilityData) }}</span>
        </div>
      </div>
  </div>
</template>


<script>
export default {
  name: 'LegendSiteMap',
  props: {
    org: { type: Object, default: () => ({ colors: [] }) },
    facilityData: { type: Object, default: {} },
    parkingPricing: { type: Object, default: {} },
    leaseStatus: { type: Boolean, default: false },
  },

  async mounted() {
    await this.getOrgColors();
  },
  data() {
    return {
      filteredColors: [],
    };
  },
  computed: {
    securityFeeLabel: function () {
      return this.facilityData && this.facilityData.securityFee && this.facilityData.securityFee.label ? this.facilityData.securityFee.label : 'Security';
    },
    securityFeeEnabled: function () {
      return this.facilityData && this.facilityData.securityFee && this.facilityData.securityFee.enabled && this.facilityData.securityFee.fee > 0;
    },
  },
  methods: {
    async getOrgColors() {
      const allowedTypes = ['CURRENT', 'LATE', 'LIEN', 'PRE_LIEN', 'AUCTION'];

      const filteredColors = this.org.colors.filter((theme) => {
        if (this.leaseStatus) {
          return allowedTypes.includes(theme.type);
        }

        return !allowedTypes.includes(theme.type);
      });

      this.filteredColors = filteredColors;
    },
  },
};
</script>


<style scoped>
* {
  font-family: monospace;
}

h3 {
  padding: 0;
  margin: 0;
}

.legend-wrapper {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.legend-section {
  text-align: start;
}

.legend-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.legend-row,
.fee-row {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.dot{
  height: 13px;
  width: 13px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.type{
  padding-left:2px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/LegendSiteMap.vue